export const resolveShopIds = shop => {
	if (!shop) {
		return []
	}
	try {
		const parsed = JSON.parse(shop.id)
		if (Array.isArray(parsed)) {
			return parsed
		}
	} catch (e) { /* single shop id */ }
	return [shop.id]
}

export const resolveMultiShopIds = shops => {
	if (shops.length === 0) {
		return []
	}
	if (shops.length === 1) {
		return resolveShopIds(shops[0])
	}
	return shops.map(s => s.id)
}
